import {TelaAcesso} from "../AcessoAplicacao";
import useSessao from "../../shared/useSessao";

function AcessoNegado() {
    return <TelaAcesso session={useSessao()} moduleDenied />;
}

export default AcessoNegado;
